//     hidden (IOS) keyboard when clicking (pointerdown) outside the form
//
//     Usage:
//     <w3-keyboard-input-search></w3-keyboard-input-search>

class KeyboardInputSearch extends HTMLElement {
    constructor () {
        super();

        this.onclickOutside = this.onclickOutside.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.bindEvents = this.bindEvents.bind(this);
    }

    connectedCallback() {

        // DOM
        this.inputSearch = this.querySelector('.js-input-search');

        this.bindEvents();
    }

    bindEvents() {
        this.inputSearch.addEventListener("focus", this.onFocus);
    }

    // listen a pointerdown on the DOM for running other function
    onFocus() {
        document.addEventListener('pointerdown', this.onclickOutside);
    }

    // when the pointerdown is detected, the target is saved. if the input target is différent about that one, the input is blured and the keyboard is closed.
    onclickOutside(evt) {
        const target = evt.target;
        const isClickedOutside = !this.inputSearch.contains(target);
  
        if (isClickedOutside) {
            this.inputSearch.blur();
        }
    }

 
}

customElements.define('w3-keyboard-input-search', KeyboardInputSearch);